import { createCustomTheme } from "./themes";
import palette from "./palette";

export const theme = createCustomTheme(palette);
